// Initialize Swiper for Hero Slider - Dynamic Sporty Design
document.addEventListener('DOMContentLoaded', function () {
  // Hero Swiper
  const heroSwiper = new Swiper('.hero-swiper', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.hero-slider .swiper-pagination',
      clickable: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    speed: 1500,
    touchRatio: 1,
    simulateTouch: true,
    allowTouchMove: true,
  });

  // Benefits Swiper
  const benefitsSwiperEl = document.querySelector('.benefits-swiper');
  if (benefitsSwiperEl) {
    const benefitsSwiper = new Swiper('.benefits-swiper', {
      speed: 1500,
      slidesPerView: 'auto',
      spaceBetween: 20,

      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },

      navigation: {
        nextEl: '.benefits-next',
        prevEl: '.benefits-prev',
      },
    });
  }

  // Smooth scroll for navigation links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        const headerHeight = document.querySelector('.header').offsetHeight;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  // Parallax effect on scroll
  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const benefitsBg = document.querySelector('.benefits-bg img');
    if (benefitsBg) {
      benefitsBg.style.transform = `translateY(${scrolled * 0.3}px)`;
    }
  });

  // Animate elements on scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
      }
    });
  }, observerOptions);

  document.querySelectorAll('.product-card, .benefit-item').forEach(el => {
    observer.observe(el);
  });


  // Hamburger Menu (SP)
  const header = document.querySelector('.header');
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const overlay = document.querySelector('.menu-overlay');

  const closeMenu = () => {
    if (!header) return;
    header.classList.remove('is-menu-open');
    document.body.classList.remove('is-scroll-locked');

    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    if (mobileMenu) mobileMenu.setAttribute('aria-hidden', 'true');
  };

  const openMenu = () => {
    if (!header) return;
    header.classList.add('is-menu-open');
    document.body.classList.add('is-scroll-locked');

    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    if (mobileMenu) mobileMenu.setAttribute('aria-hidden', 'false');
  };

  if (hamburger) {
    hamburger.addEventListener('click', () => {
      if (header.classList.contains('is-menu-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  // ★Overlayクリックで必ず閉じる
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation(); // 念のため
      if (header.classList.contains('is-menu-open')) {
        closeMenu();
      }
    });
  }

  // メニュー内リンク押したら閉じる
  document.querySelectorAll('.mobile-menu a[href^="#"]').forEach(link => {
    link.addEventListener('click', () => {
      closeMenu();
    });
  });

  // ESCで閉じる
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });



  // Header scroll class toggle（10px超で付与）
  const toggleHeaderScrollClass = () => {
    if (!header) return;

    if (window.scrollY > 10) {
      header.classList.add('--isScroll');
    } else {
      header.classList.remove('--isScroll');
    }
  };

  // 初期状態チェック
  toggleHeaderScrollClass();

  // スクロール時に切替
  window.addEventListener('scroll', toggleHeaderScrollClass);
});
